import { useEffect, useState } from "react";

const LOCAL_STORAGE_KEY = "boardo:ipCity";

interface CachedCity {
  city: string | null;
  fetchedAt: number;
}

const CACHE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

export function useIpCity(): string | null {
  const [city, setCity] = useState<string | null>(() => {
    try {
      const raw = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw) as CachedCity;
      if (Date.now() - parsed.fetchedAt < CACHE_TTL_MS) return parsed.city;
      return null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (city !== null) return;
    let cancelled = false;
    fetch("https://ipapi.co/json/")
      .then((r) => (r.ok ? r.json() : null))
      .then((data: { city?: string } | null) => {
        if (cancelled) return;
        const resolved = data?.city ?? null;
        try {
          localStorage.setItem(
            LOCAL_STORAGE_KEY,
            JSON.stringify({ city: resolved, fetchedAt: Date.now() } satisfies CachedCity)
          );
        } catch {
          // ignore storage errors (private mode, quota)
        }
        if (resolved) setCity(resolved);
      })
      .catch(() => {
        // network or CORS failure — silently ignore
      });
    return () => {
      cancelled = true;
    };
  }, [city]);

  return city;
}
